import {
    isoAndUnixZodSchema,
    nowIsoAndUnix,
} from "@@/shared/date-time/iso-and-unix";
import { idZodSchema } from "@@/shared/id";
import { productIdZodSchema } from "@@/shared/products/product-id";
import { generateId } from "@@/utilities/generate-id";
import type { Except } from "type-fest";
import { z } from "zod";

const channexJobSyncIntegrationCommandZodSchema = z.object({
    _id: idZodSchema,
    _type: z.literal("CHANNEX_JOB_SYNC_INTEGRATION_COMMAND"),
    _createdAt: isoAndUnixZodSchema,

    productId: productIdZodSchema,

    // forceAll: z.boolean(),

    // resourceGroupId: resourceIdZodSchema,
    // rateId: accommodationRateIdZodSchema,
});

type ChannexJobSyncIntegrationCommand = z.infer<
    typeof channexJobSyncIntegrationCommandZodSchema
>;

type FactoryParams = Except<
    ChannexJobSyncIntegrationCommand,
    "_id" | "_type" | "_createdAt"
>;
const channexJobSyncIntegrationCommandFactory = (params: FactoryParams) => {
    const command: ChannexJobSyncIntegrationCommand = {
        ...params,
        _id: generateId({ prefix: "channex__" }),
        _type: "CHANNEX_JOB_SYNC_INTEGRATION_COMMAND",
        _createdAt: nowIsoAndUnix(),
    };
    return command;
};

export {
    channexJobSyncIntegrationCommandFactory,
    channexJobSyncIntegrationCommandZodSchema,
};
export type { ChannexJobSyncIntegrationCommand };
